import { MotifButton, MotifCardFooter, MotifFormField, MotifInput, MotifOption, MotifSearch, MotifSelect, MotifTextArea } from '@ey-xd/motif-react'
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

function UserForm(props) {
    const { onFormSubmit, onCancel, data, formData } = props;
    const roleData = formData.roleData.filter((ele)=> ele.Role_status == "Active");
    const groupData = formData.groupData.filter((ele)=> ele.groupStatus == "Active");

    const [suggestions, setSuggestions] = useState([]);
    const [nameSearch, setNameSearch] = useState("");

    // Function to call the API and fetch suggestions
    const fetchSuggestions = async (inputValue) => {
        try {
            const response = await axios.get(`/admin/users-search?user=${inputValue}`)
            const data = response?.data;
            if (data?.value) {
                setSuggestions(data?.value)
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        }
    };

    const { control, setValue, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            name: '',
            email: 'test_user@ey.ges.com', // make this email dynamically
            userRole: '',
            roleName: '',
            userGroup: '',
            status: 'Active',
        }
    });

    useEffect(() => {
        if (data) {
            let groupId;
            if (data?.groupRelation.length) {
                groupId = data.groupRelation[0].groupId
            }
            setNameSearch(data?.name)
            setValue("name", data?.name)
            setValue("email", data?.email)
            setValue("userRole", data?.roleId)
            setValue("roleName", data?.roleName)
            setValue("userGroup", groupId)
            setValue("status", data?.userStatus)
        }
    }, [data])

    useEffect(() => {
        let timer = setTimeout(() => {
            if (nameSearch !== "") {
                fetchSuggestions(nameSearch);
            } else {
                setValue("name", "");
                setValue("email", "");   
            }
        }, 1500)
        return () => clearTimeout(timer)
    }, [nameSearch])

    const onSubmit = (data) => {
        if(data?.name && data?.name !== "" && data?.email && data?.email !== "") {
            onFormSubmit(data);
        }
        // alert("Please select user");
    };
    const roleChange = (val) => {
        if (val) {
            const selectedRole = roleData.find(role => role.RoleId === val)
            setValue("roleName", selectedRole?.RoleName)
            setValue("userRole", val)
        }
    }

    const getSuggestedNames = useMemo(() => {
        return (suggestions ?? [])?.map((sug: any) => sug?.displayName)
    }, [suggestions])

    return (
        <div>
            <div className='flex flex-col'>
                <div className="flex gap-3 mb-3 !w-full">
                    {/* <div> */}
                    <div className='w-3/12'>
                        <MotifFormField label="Name">
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: 'User name is required' }}
                                render={({ field }) => (
                                    <MotifSearch
                                        // {...field}
                                        value={nameSearch}
                                        items={getSuggestedNames}
                                        // onInputChange={(event, newInputValue) => {
                                        //     fetchSuggestions(newInputValue);
                                        // }}
                                        // getOptionLabel={(option) => option.name} // Assuming the suggestion object has a 'name' property
                                        // renderOption={(props, option) => (
                                        //     <li {...props}>
                                        //         {option.name} - {option.email}
                                        //     </li>
                                        // )}

                                        onChange={(event) => {
                                            setNameSearch(event.target.value)
                                        }}
                                        onSelect={(val) => {
                                            setNameSearch(val);
                                            const found: any = suggestions?.find((sug: any) => sug?.displayName === val)
                                            if(found) {
                                                setValue("name", found.displayName);
                                                setValue("email", found.mail);    
                                            }
                                        }}
                                        placeholder="Name"
                                        disabled={!!data?.name}
                                    />
                                )}
                            />
                            {errors.name && <p>{errors.name.message}</p>}
                        </MotifFormField>
                        {/* <MotifFormField label="group name">
                            <Controller
                                name="name"
                                control={control}
                                render={({ field }) => (
                                    <MotifInput hideClearButton {...field} placeholder="Name" />
                                )}
                            />
                        </MotifFormField> */}
                    </div>
                    <div className="w-3/12">
                        <MotifFormField label="Role">
                            <Controller
                                name="userRole"
                                control={control}
                                rules={{ required: 'User role is required' }}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select role" visibleOptions={3} onChange={roleChange}>
                                        <MotifOption value="" disabled>Select role</MotifOption>
                                        {roleData.map(option => (
                                            <MotifOption value={option.RoleId} >{option.RoleName}</MotifOption>
                                        ))
                                        }
                                    </MotifSelect>
                                )}
                            />
                            {errors.userRole && <p>{errors.userRole.message}</p>}
                        </MotifFormField>
                    </div>
                    <div className="w-3/12">
                        <MotifFormField label="User Group">
                            <Controller
                                name="userGroup"
                                control={control}
                                rules={{ required: 'User group is required' }}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select group" visibleOptions={3} >
                                        <MotifOption value="" disabled>Select group</MotifOption>
                                        {groupData.map(option => (
                                            <MotifOption value={option.groupId} >{option.groupName}</MotifOption>
                                        ))
                                        }
                                    </MotifSelect>
                                )}
                            />
                            {errors.userGroup && <p>{errors.userGroup.message}</p>}
                        </MotifFormField>
                    </div>
                    <div className="w-3/12">
                        <MotifFormField label="Status">
                            <Controller
                                name="status"
                                control={control}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select status" visibleOptions={3}>
                                        <MotifOption value="Active">Active</MotifOption>
                                        <MotifOption value="Inactive">Inactive</MotifOption>
                                    </MotifSelect>
                                )}
                            />
                        </MotifFormField>
                    </div>
                    {/* </div> */}

                </div>

                <hr style={{ opacity: "0.1" }} />
                <MotifCardFooter className="justify-end mt-3">
                    <MotifButton
                        onClick={onCancel}
                        type="button"
                        variant="secondary"
                        size="small"
                        className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                    >
                        Cancel
                    </MotifButton>
                    <MotifButton
                        type="submit"
                        variant="primary"
                        size="small"
                        onClick={handleSubmit(onSubmit) as any}
                        className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                    >
                        Save
                    </MotifButton>
                </MotifCardFooter>
            </div>
        </div>
    )
}

export default UserForm